import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';
import { CellFieldV2 as CellField } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

export const getTableColumns = (
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void,
  formMode: FormMode
): DataTableColumn[] => [
  {
    field: 'ma_cp',
    headerName: 'Mã chi phí',
    width: 180,
    renderCell: params => params.row.ma_cp_data?.ma_cp
  },
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 180,
    renderCell: params => params.row.ma_vt_data?.ma_vt
  },
  {
    field: 'tien_cp_nt',
    headerName: 'Tiền VNĐ',
    width: 150,
    renderCell: params => (
      <CellField
        name='tien_cp_nt'
        type='number'
        commitOnBlur
        value={params.row.tien_cp_nt || 0.0}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'tien_cp_nt', newValue)}
        disabled={formMode === 'view'}
      />
    )
  },
  {
    field: 'line_vt',
    headerName: 'Dòng vật tư',
    width: 120,
    renderCell: params => params.row.line_vt || 1
  },
  {
    field: 'line_cp',
    headerName: 'Dòng chi phí',
    width: 120,
    renderCell: params => params.row.line_cp || 1
  }
];
